export enum StatementType {
  DELIVERABLE = 'Deliverable',
  TASK = 'Task'
}
